const module = { name: 'movie/overview/desktop.app', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_dateUtil as Fandango_dateUtil_dateFromQuery } from 'require-global';

const { dateFromQuery } = Fandango_dateUtil_dateFromQuery;


import { Fandango_eventQueue as eventQueue } from 'require-global';



const { EventNames } = eventQueue


import { fd_location as fd_location_locationFormCreation_updateLocation_getLocation } from 'require-global';

const { locationFormCreation, updateLocation, getLocation } = fd_location_locationFormCreation_updateLocation_getLocation;


import { default as shared_utils_objUtils_pick } from 'swug-fdRequire-call:shared/utils/objUtils';

const { pick } = shared_utils_objUtils_pick;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Splide as Splide } from 'require-core';



import { Fandango as Fandango_context_pageDetails } from 'require-core';

const { context: { featureFlags: { permissionTrialEnabled } }, pageDetails: { allowsMopTranslation, mopUrlZip }, } = Fandango_context_pageDetails;


import { default as i18n } from 'swug-fdRequire-call:shared/global/Fandango.i18n';



import { default as bannerMPS } from 'swug-fdRequire-call:movie/shared/bannerMPS';



import { default as calendarUI } from 'swug-fdRequire-call:movie/shared/calendarUI';



import { default as features } from 'swug-fdRequire-call:movie/overview/features';



import { default as videos } from 'swug-fdRequire-call:movie/shared/desktop/videos';



import { default as headerUI } from 'swug-fdRequire-call:movie/overview/headerUI.desktop';



import { default as historyStates } from 'swug-fdRequire-call:movie/shared/historyStates';



import { default as marketingSpotlight } from 'swug-fdRequire-call:shared/desktop/marketingSpotlight';



import { default as movieStateUI } from 'swug-fdRequire-call:movie/shared/desktop/movieStateUI';



import { default as onDemandUI } from 'swug-fdRequire-call:movie/shared/mop.onDemandUI';



import { default as showtimesUI } from 'swug-fdRequire-call:movie/shared/showtimesUI';



import { default as videoLinksUI } from 'swug-fdRequire-call:movie/shared/desktop/videoLinksUI';



import { default as worker } from 'swug-fdRequire-call:shared/movies/movieState.worker';



import { default as newFanalert } from 'swug-fdRequire-call:movie/overview/newFanalert';



import { default as viewToggleBtns } from 'swug-fdRequire-call:movie/shared/mop.viewToggleBtns';



import { shared_global_globalTooltipModule as globalTooltipModule } from 'require-global';



const Selectors = {
    FAN_ALERT_FORM: '#fanalert-form',
    GEOLOCATION_PERMISSION: '#geolocation',
    TRANSLATE_BUTTON: '#js-translate-button',
    MOVIE_DETAIL_HEADER_REVIEW_CONTAINER: '.movie-detail-header__reviews',
    GLOBAL_TOOLTIP_MOP_PLACEHOLDER: '#global-tooltip-placeholder-mop',
    GLOBAL_TOOLTIP_ON_DEMAND_PLACEHOLDER: '#global-tooltip-placeholder-on-demand',
    GLOBAL_TOOLTIP_ON_DEMAND: '.global-tooltip__container--mop-mobile-at-home',
    VIEWING_TYPE_TOGGLE_INFO: '.js-viewing-type-toggle__info',
}


const Styles = {
    HIDE: 'hide',
}


const ViewingTypes = {
    BUY_TICKETS: 'buytickets',
}
function onCalendarChange(status, err, results, workerContext) {
    const { StatusTypes } = worker;
    switch (status) {
        case StatusTypes.FETCHING:
            calendarUI.busy();
            showtimesUI.busy();
            break;
        case StatusTypes.SUCCESS: {
            const { movie, movieState, movieAttribs, request: { initialRequestDate } } = workerContext;
            calendarUI.done(results, movie, movieState, movieAttribs, { initialRequestDate });
            break;
        }
        default:
            calendarUI.error(err);
            break;
    }
}
function onShowtimesChange(status, err) {
    const { StatusTypes } = worker;
    switch (status) {
        case StatusTypes.FETCHING:
            showtimesUI.busy();
            break;
        case StatusTypes.SUCCESS:
            break;
        default:
            showtimesUI.error(err);
            break;
    }
}
function onInTheatersDone(status, err, results, workerContext) {
    const { StatusTypes } = worker;
    if (status !== StatusTypes.SUCCESS) {
        return;
    }
    showtimesUI.done(Object.assign(pick(results, 'adobeLaunch', 'movie', 'movieAttribs', 'movieState', 'showtimes'), pick(workerContext.request, 'date')));
}
function onOnDemandDone(status, err, results) {
    const { StatusTypes } = worker;
    if (status !== StatusTypes.SUCCESS) {
        return;
    }
    onDemandUI.done(Object.assign(pick(results.movie, 'id', 'genre', 'lowestStreamingPrice', 'offer', 'releaseDate', 'sluggedTitle', 'streamingServices', 'title', 'poster', 'vuduMovieId'), pick(results.movieAttribs, 'showFanalert', 'showStreaming', 'showStreamingPresale'), pick(results.adobeLaunch, 'trackingState', 'trackingAttribs'), pick(results.movieState, 'isTicketingWindow', 'isNotTicketingWindow'), {
        isDesktop: true
    }));
}
function onDone(status, err, results, workerContext) {
    viewToggleBtns.init(results);
    onOnDemandDone(status, err, results);
    onInTheatersDone(status, err, results, workerContext);
    initGlobalTooltip();
}
function onCalendarDateChange(selectedDate) {
    if (selectedDate) {
        movieStateUI.update({
            date: selectedDate,
            allowSameDateCalendarUpdate: true
        });
    }
}
function onHistoryChange(type, data) {
    if (type === historyStates.HistoryEventTypes.CALENDAR) {
        const { date, location } = data;
        updateLocation(location);
        movieStateUI.update({
            date,
            location,
            allowSameDateCalendarUpdate: true
        });
    }
}
function onLocationChange() {
    worker.update({
        date: dateFromQuery('d'),
        location: getLocation(),
        allowSameDateCalendarUpdate: true
    });
}
function setupTranslator() {
    const movieDetailHeaderReviewContainer = document.querySelector(Selectors.MOVIE_DETAIL_HEADER_REVIEW_CONTAINER);
    if (movieDetailHeaderReviewContainer) {
        movieDetailHeaderReviewContainer.insertAdjacentHTML('afterend', '<button id="js-translate-button" class="btn">Traducir a Español</button>');
    }
    i18n.init(i18n.Languages.ENGLISH, i18n.Languages.SPANISH);
    const translationButton = document.querySelector(Selectors.TRANSLATE_BUTTON);
    if (translationButton) {
        translationButton.addEventListener('click', () => {
            i18n.translate().then(r => console.log(r));
            if (!i18n.getIsTranslating()) {
                translationButton.innerHTML = 'Translate to English';
            }
            else {
                translationButton.innerHTML = 'Traducir a Español';
            }
        });
    }
}
function initGlobalTooltip() {
    const mopPlaceholderExists = Boolean(document.querySelector(Selectors.GLOBAL_TOOLTIP_MOP_PLACEHOLDER));
    if (mopPlaceholderExists) {
        const tooltipOpts = {
            selector: Selectors.GLOBAL_TOOLTIP_MOP_PLACEHOLDER,
            page: globalTooltipModule.Pages.MOVIE_OVERVIEW,
            overrideClass: 'global-tooltip__container--mop-mobile-buy-tickets dark__section',
            placement: globalTooltipModule.Constants.AFTEREND
        };
        globalTooltipModule.initInline(tooltipOpts);
    }
    const onDemandPlaceholderExists = Boolean(document.querySelector(Selectors.GLOBAL_TOOLTIP_ON_DEMAND_PLACEHOLDER));
    const onDemandTooltipExists = Boolean(document.querySelector(Selectors.GLOBAL_TOOLTIP_ON_DEMAND));
    if (onDemandPlaceholderExists && !onDemandTooltipExists) {
        const renderTooltip = (hideTooltip) => {
            const styleOverride = hideTooltip ?
                'global-tooltip__container--mop-mobile-at-home dark__section viewing-type-toggle__hide' :
                'global-tooltip__container--mop-mobile-at-home dark__section';
            const tooltipOpts = {
                selector: Selectors.GLOBAL_TOOLTIP_ON_DEMAND_PLACEHOLDER,
                page: globalTooltipModule.Pages.MOVIE_OVERVIEW,
                overrideClass: styleOverride,
                placement: globalTooltipModule.Constants.AFTEREND
            };
            globalTooltipModule.initInline(tooltipOpts);
        };
        const currentTab = viewToggleBtns.getCurrentTab();
        const viewingTypeToggleInfoExists = Boolean(document.querySelector(Selectors.VIEWING_TYPE_TOGGLE_INFO));
        if (currentTab) {
            const isBuyTickets = currentTab === ViewingTypes.BUY_TICKETS;
            renderTooltip(isBuyTickets);
        }
        else if (!viewingTypeToggleInfoExists) {
            renderTooltip(mopPlaceholderExists);
        }
    }
}
function run() {
    checkDependencies(module.name, debugLog);
    calendarUI.addDependency({ Splide });
    features.init();
    videos.init();
    headerUI.attach();
    historyStates.attach(onHistoryChange);
    calendarUI.setOnDateChange(onCalendarDateChange);
    marketingSpotlight.init();
    videoLinksUI.attach();
    eventQueue.on(EventNames.FAN_ALERT_READY, () => {
        newFanalert.init();
        bannerMPS.insertBannerTopAd({
            hasShowtimes: false,
            selector: Selectors.FAN_ALERT_FORM
        });
        bannerMPS.displayBannerTopAd();
    });
    if (allowsMopTranslation) {
        setupTranslator();
    }
    locationFormCreation.init({ zip: mopUrlZip });
    locationFormCreation.attach(onLocationChange);
    const geolocationPermission = $(Selectors.GEOLOCATION_PERMISSION);
    if (permissionTrialEnabled
        && geolocationPermission.width()
        && window.navigator.userAgentData?.brands.some(b => b.brand === 'Google Chrome' && parseInt(b.version) >= 126)) {
        geolocationPermission.removeClass(Styles.HIDE);
    }
    movieStateUI.run({
        isDesktopMOP: true,
        bypassCalendarFetch: false,
        onCalendarChange,
        onShowtimesChange,
        onDone,
    });
}
run();
export default module.exports;